<template>
  <div>
    <vxe-pulldown ref="bankDown" transfer style="width: 100%">
      <template v-slot>
        <vxe-input v-model="row.openBankName" placeholder="请输入并选择开户行" @focus="bankFocusEvent"
                   @keyup="bankKeyupEvent" @blur="checkOrg"></vxe-input>
      </template>
      <template v-slot:dropdown>
        <div class="my-dropdown1">
          <div
              class="list-item1"
              v-for="item in bankList"
              :key="item.id"
              @click="bankSelectEvent(item)"
          >
            <i class="fa fa-user-o"></i>
            <span>{{ item.orgName }}</span>
          </div>
        </div>
      </template>
    </vxe-pulldown>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {isEmpty} from "@/utils/util";

export default {
  name: "SelectBankName",
  props: ['row'],
  data() {
    return {
      bankList: []
    }
  },

  methods:{
    checkOrg() {
      if (!this.row.openOrgNum || !this.chooseBank) {
        this.row.openBankName = '';
      }
    },
    bankFocusEvent() {
      this.$refs.bankDown.showPanel();
    },
    bankKeyupEvent() {
      this.chooseBank = false;
      this.getBankListByName();
    },
    bankSelectEvent(obj) {
      this.chooseBank = true;
      this.row.bankName = obj.orgName;
      this.row.openBankName = obj.orgName
      this.row.openOrgNum = obj.orgNum;
      this.$refs.bankDown.hidePanel();
    },
    async getBankListByName() {
      let name = this.row.openBankName;
      if (isEmpty(name)){
        this.bankList = []
        return
      }
      let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
      if (res.status === 1 && name === res.message) {
        this.bankList = res.data;
      }
    },
  }

}
</script>

<style scoped>

</style>
